"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GiftCardType;
(function (GiftCardType) {
    GiftCardType[GiftCardType["Merrco"] = 1] = "Merrco";
    GiftCardType[GiftCardType["Birchmount"] = 2] = "Birchmount";
})(GiftCardType = exports.GiftCardType || (exports.GiftCardType = {}));
//# sourceMappingURL=GiftCards.js.map